import React, { useState } from "react";
import Container from "@mui/material/Container";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
//import axios from "axios";
import CardMedia from "@mui/material/CardMedia";
import logo from "../img/logo.png";
import helperPersona from "../helpers/persona";

import { useDispatch } from "react-redux";
import { setUser } from "../store/userSlice";
import authService from "../services/maestros.service";
import { useNavigate } from "react-router-dom";

import { API_SERVER } from "../store";

const Login = ({ onLogin }) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    pass: "",
    showPass: false,
  });

  const [rut, setRut] = useState("");

  const [error, setError] = useState({
    error: false,
    message: "",
  });

  const [errorpass, setErrorpass] = useState({
    error: false,
    message: "",
  });

  const [errorBd, setErrorBd] = useState({
    error: false,
    message: "",
  });

  const handlePassVisibility = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };

  // Change para que el string se acumule
  const handleChangeRut = (event) => {
    setRut(event.target.value);
  };

  // LostFocus
  const handlelostFocusRut = () => {
    setRut(helperPersona.rutFormato(rut));
  };
  // Focus
  const handleFocusRut = () => {
    setRut(helperPersona.rutSinFormato(rut));
  };

  const handleChangePass = (e) => {
    const newValue = e.target.value;
    setValues((prevValues) => ({ ...prevValues, pass: newValue }));
    setErrorBd({
      error: false,
      message: "",
    });
  };

  const navigate = useNavigate();

  const Precionado = () => {
    if (!helperPersona.rutValidar(rut)) {
      setError({
        error: true,
        message: "El rut digitado no es valido",
      });
      return;
    }

    setError({
      error: false,
      message: "",
    });

    if (API_SERVER === "api.gandara.cl") {
      if (values.pass.length < 4) {
        setErrorpass({
          error: true,
          message: "El password debe ser superior a 4 caracteres",
        });
        return;
      }
    }

    setErrorpass({
      error: false,
      message: "",
    });
    // consultando a la base de datos para extraccion de pass y rut.

    authService
      .login(helperPersona.rutFormatoBaseDatos(rut), values.pass)
      .then((data) => {
        // Esta bien
        if (data.status === 200) {
          // Grabando token
          dispatch(setUser(data.data));
          onLogin();
          navigate("/dashboard");
        } else if (data.status === 400) {
          // Esta mal
          //  console.log(data)
          setErrorBd({
            error: true,
            message: "Error BD : " + data.status + " Msj: " + data.data.msg,
          });
        }
      });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    Precionado();
  };

  return (
    <div>
      <Container maxWidth="sm">
        <Grid
          container
          spacing={2}
          direction="column"
          justifyContent={"center"}
          sx={{ p: 2 }}
          // style={{ minHeight: "100vh" }}
        >
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <Paper elevation={4} sx={{ padding: 5 }}>
              <Box component="form" onSubmit={onSubmit} autoComplete="off">
                <Grid container direction={"column"} spacing={2}>
                  <CardMedia
                    component="img"
                    // maxWidth="xs"
                    sx={{ height: "auto" }}
                    image={logo}
                    title="logo gandara"
                  />
                  <Grid item>
                    <TextField
                      label="Rut"
                      variant="outlined"
                      id="rut"
                      type="rut"
                      fullWidth
                      required
                      error={error.error}
                      helperText={error.message}
                      onChange={handleChangeRut}
                      onBlur={handlelostFocusRut}
                      onFocus={handleFocusRut}
                      value={rut}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      type={values.showPass ? "text" : "password"}
                      fullWidth
                      label="Digite su Password"
                      placeholder="Password"
                      error={errorpass.error}
                      helperText={errorpass.message}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handlePassVisibility}
                              aria-label="toggle password"
                              edge="end"
                            >
                              {values.showPass ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      required
                      onChange={handleChangePass}
                      // {(e)=>setValues({...values, pass:e.target.value})}
                    />
                  </Grid>
                  <Grid item>
                    {/* <Button type="submit" fullWidth variant="contained">
                    Iniciar sesión
                  </Button> */}
                    <Button type="submit" fullWidth variant="contained">
                      Iniciar sesión
                    </Button>
                  </Grid>
                  {errorBd.error && (
                    <Grid item>
                      <Alert severity="error">
                        <AlertTitle>Error de acceso </AlertTitle>
                        <strong>{errorBd.message}</strong>
                      </Alert>
                    </Grid>
                  )}
                </Grid>
              </Box>

              {/* <Alert severity="error"><AlertTitle>Error</AlertTitle>  This is an error alert — <strong>check it out!</strong></Alert>
                    <Alert severity="warning"><AlertTitle>Warning</AlertTitle>This is a warning alert — <strong>check it out!</strong></Alert>
                    <Alert severity="info">  <AlertTitle>Info</AlertTitle>  This is an info alert — <strong>check it out!</strong></Alert>
                    <Alert severity="success">  <AlertTitle>Success</AlertTitle>  This is a success alert — <strong>check it out!</strong></Alert>                     */}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Login;
